<div class="filter-container">
    <div class="row filter-row">
        <div class="col-md-auto">
            <div class="search-bar">
                <i class="pi pi-search mr-2" pTooltip="Click to search" tooltipPosition="bottom" style="margin: 4px 2px 0 0"></i>
                <input type="text" placeholder="Search item groups" pInputText
                    [(ngModel)]="globalSearch"
                    (input)="onSearchInput()"
                    class="searchStyle" />
            </div>
        </div>
    </div>
</div>
<div class="med-table-container">
    <p-table
        [value]="medicationData"
        [paginator]="true"
        [rows]="20"
        [showFirstLastIcon]="true"
        sortMode="single"
        [tableStyle]="{ 'min-width': '60rem' }">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="assayManagementEnabled ? 5 : 4" class="empty-table-message">No item groups found.</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th scope="col" pSortableColumn="medGroupName" style="text-align:start">Item Group <p-sortIcon field="medGroupName"></p-sortIcon></th>
                <th scope="col" style="width:10rem;">Total Mapped Items</th>
                <th scope="col" pSortableColumn="diversionWeight" style="width:10rem;">Diversion Weight <p-sortIcon field="diversionWeight"></p-sortIcon></th>
                <th *ngIf="assayManagementEnabled" scope="col" pSortableColumn="assayTrackable" style="width:10rem;">Assay Trackable <p-sortIcon field="assayTrackable"></p-sortIcon></th>
                <th scope="col" pSortableColumn="updatedAt" style="width:14rem;">Last Updated <p-sortIcon field="updatedAt"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-med>
            <tr tabindex="0"
                (click)="onRowActivate(med)"
                style="cursor: pointer;">
                <td>{{ med.medGroupName }}</td>
                <td style="text-align:center">{{ getTotalMappedItems(med) }}</td>
                <td style="text-align:center">{{ getWeightLabel(med.diversionWeight) }}</td>
                <td *ngIf="assayManagementEnabled" style="text-align:center">{{ med.assayTrackable ? 'Yes' : 'No' }}</td>
                <td style="text-align:center">
                    <div class="updated-at-cell">
                        @if (med.updatedBy) {
                            <span class="updated-by">{{ med.updatedBy }}</span>
                        }
                        <span>{{ med.updatedAt | date : 'MM/dd/yyyy HH:mm' }}</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
